import React from "react";

function WhyChPolkadot() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Polkadot for Your Blockchain Project?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Polkadot’s unique multi-chain framework allows for seamless
                  interoperability between different blockchains, making it a
                  game-changer for cross-chain applications. By enabling
                  parachains and supporting decentralized networks, Polkadot
                  creates a scalable, flexible environment for DApps, DeFi
                  projects, and enterprise solutions.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyChPolkadot;
